export const FORM_INNER_WIDTH = 400;

export const STEPPER_LABELS = ["Personal Info", "Company Info", "Schedule"];

export const STEPPER_LABELS_TWO_STEPS_DEMO_FORM = ["Add Your Info", "Schedule"];
